import React, { useEffect } from 'react';
import { Box, useColorMode } from '@chakra-ui/react';
import { Route, Switch, useLocation } from 'react-router-dom';
import { LegalLangProvider } from './LegalLangContext';
import LegalHeader from './components/LegalHeader';
import LegalFooter from './components/LegalFooter';
import LegalIndex from './LegalIndex';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';

// Public layout cho /legal/* — KHÔNG yêu cầu đăng nhập, không
// dùng Sidebar/AdminNavbar. Cố định light mode để trang pháp lý
// luôn nhất quán cho App Reviewer.
export default function LegalLayout() {
  const { setColorMode } = useColorMode();
  const location = useLocation();

  useEffect(() => {
    setColorMode('light');
    document.body.style.overflow = 'unset';
  }, [setColorMode]);

  useEffect(() => {
    // Scroll lên đầu khi đổi route trừ khi URL có hash (anchor link).
    if (!window.location.hash) {
      window.scrollTo({ top: 0, behavior: 'auto' });
    }
  }, [location.pathname]);

  return (
    <LegalLangProvider>
      <Box minH="100vh" bg="surface.base" display="flex" flexDirection="column">
        <LegalHeader />
        <Box as="main" flex={1}>
          <Switch>
            <Route exact path="/legal" component={LegalIndex} />
            <Route exact path="/legal/" component={LegalIndex} />
            <Route exact path="/legal/:platform/terms" component={TermsPage} />
            <Route exact path="/legal/:platform/privacy" component={PrivacyPage} />
            {/* URL clean cho TikTok review (không chứa "tiktok") — render policy của tiktok */}
            <Route exact path="/privacy-policy" render={() => <PrivacyPage platformOverride="tiktok" />} />
            <Route exact path="/terms-of-service" render={() => <TermsPage platformOverride="tiktok" />} />
            <Route path="/legal/*" component={LegalIndex} />
          </Switch>
        </Box>
        <LegalFooter />
      </Box>
    </LegalLangProvider>
  );
}
